/* ============================================================
   HYRALUXE PDP — gallery, colourways, zoom, tabs, pincode, buy bar.

   Behaviour ported from the prototype. The catalogue is Shopify's now, so a
   colour change swaps the *variant* — price, stock, SKU, the add button and the
   URL all move together, and the gallery scrolls to that colourway's own
   photograph rather than re-rendering a list this file keeps.
   ============================================================ */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const toast = msg => (window.hyraToast ? window.hyraToast(msg) : null);

  const track = $('#pdp-track');
  if (!track) return;

  let VARIANTS = [];
  try { VARIANTS = JSON.parse($('#pdp-variants').textContent); } catch (err) { VARIANTS = []; }

  const money = cents => (window.hyraMoney ? window.hyraMoney(cents) : '₹' + Math.round(cents / 100));

  /* ---------------- Gallery ---------------- */
  const colourNameText = () => {
    const el = $('#pdp-colour-name');
    return el ? el.textContent : '';
  };

  const dotsWrap = $('#gal-dots');
  const thumbsWrap = $('#pdp-thumbs');
  const counter = $('#pdp-counter');
  const slides = () => $$('.pdp-slide', track);

  /* Only the selected colourway's photographs are in play. Hidden slides leave
     the layout entirely, so the scroll-snap track stays contiguous and index
     arithmetic keeps working. */
  const shown = () => slides().filter(s => !s.hidden);
  const visibleDots = () => (dotsWrap ? $$('.gdot', dotsWrap).filter(d => !d.hidden) : []);
  const visibleThumbs = () => (thumbsWrap ? $$('.pthumb', thumbsWrap).filter(t => !t.hidden) : []);

  const activeIndex = () => {
    const w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  };
  const lastIndex = () => Math.max(shown().length - 1, 0);

  const syncUI = () => {
    const i = activeIndex();
    if (counter) counter.textContent = (i + 1) + '/' + shown().length;
    visibleDots().forEach((d, di) => d.classList.toggle('active', di === i));
    visibleThumbs().forEach((t, ti) => t.classList.toggle('active', ti === i));
  };

  const norm = v => String(v == null ? '' : v).trim().toLowerCase();

  /* Exact colour match first. Only if the catalogue has nothing under that exact
     name do we fall back to a looser one — that is what lets the variant named
     "Blue" find photographs tagged "Blue Grey" without letting "Grey" swallow
     them, since "Grey" has an exact set of its own. */
  const pickForColour = (els, colour) => {
    const want = norm(colour);
    if (!want) return els;
    let hit = els.filter(el => norm(el.dataset.colour) === want);
    if (!hit.length) hit = els.filter(el => {
      const c = norm(el.dataset.colour);
      return c && (c.indexOf(want) > -1 || want.indexOf(c) > -1);
    });
    return hit.length ? hit : els;
  };

  const showColour = colour => {
    const all = slides();
    const keep = new Set(pickForColour(all, colour));
    all.forEach(el => { el.hidden = !keep.has(el); });

    if (dotsWrap) {
      const d = $$('.gdot', dotsWrap);
      const keepD = new Set(pickForColour(d, colour));
      d.forEach(el => { el.hidden = !keepD.has(el); });
    }
    if (thumbsWrap) {
      const t = $$('.pthumb', thumbsWrap);
      const keepT = new Set(pickForColour(t, colour));
      t.forEach(el => { el.hidden = !keepT.has(el); });
      /* a single photograph is not a strip */
      thumbsWrap.hidden = keepT.size < 2;
    }

    track.scrollLeft = 0;
    syncUI();
  };
  const goTo = i => track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });

  track.addEventListener('scroll', () => requestAnimationFrame(syncUI), { passive: true });
  const prevBtn = $('#gal-prev'), nextBtn = $('#gal-next');
  if (prevBtn) prevBtn.addEventListener('click', () => goTo(Math.max(activeIndex() - 1, 0)));
  if (nextBtn) nextBtn.addEventListener('click', () => goTo(Math.min(activeIndex() + 1, lastIndex())));
  if (dotsWrap) dotsWrap.addEventListener('click', e => {
    const d = e.target.closest('.gdot');
    if (d) goTo(visibleDots().indexOf(d));
  });
  if (thumbsWrap) thumbsWrap.addEventListener('click', e => {
    const t = e.target.closest('.pthumb');
    if (t) goTo(visibleThumbs().indexOf(t));
  });

  /* open on the colourway the server rendered */
  showColour(colourNameText());

  /* ---------------- Colourways → variant ----------------
     No page reload: the whole buy box follows the variant, and the URL is
     rewritten so the link someone copies opens the colour they were looking at. */
  const priceRow = $('#pdp-price-row');
  const stockEl = $('#pdp-stock');
  const colourName = $('#pdp-colour-name');
  const badgeEl = $('#pdp-badge');
  const addBtn = $('#btn-addbag');
  const buyNow = $('#btn-buynow');
  const buyBar = $('.buy-bar');
  const barBtn = $('.buy-bar [data-add]');
  const barPrice = $('#buy-price');
  const variantField = $('[data-variant-field]');
  const LOW = 5;

  const syncBuyBar = () => {
    if (!buyBar || !addBtn) return;
    if (window.matchMedia('(min-width: 900px)').matches) {
      buyBar.classList.remove('is-visible');
      document.body.classList.remove('buy-bar-visible');
      return;
    }

    const rect = addBtn.getBoundingClientRect();
    const addButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight - 14;
    const shouldShow = window.scrollY > 160 && !addButtonVisible;
    buyBar.classList.toggle('is-visible', shouldShow);
    document.body.classList.toggle('buy-bar-visible', shouldShow);
  };

  let buyBarFrame = 0;
  const queueBuyBarSync = () => {
    if (buyBarFrame) return;
    buyBarFrame = requestAnimationFrame(() => {
      buyBarFrame = 0;
      syncBuyBar();
    });
  };

  if (buyBar) {
    syncBuyBar();
    window.addEventListener('scroll', queueBuyBarSync, { passive: true });
    window.addEventListener('resize', queueBuyBarSync);
  }

  const applyVariant = variant => {
    if (!variant) return;

    if (priceRow) {
      let html = '<span class="price-now">' + money(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<span class="price-mrp">' + money(variant.compare_at_price) + '</span>' +
                '<span class="price-off">' + off + '% OFF</span>';
      }
      priceRow.innerHTML = html;
    }

    if (barPrice) {
      let html = '<span class="p">' + money(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<span class="sub"><s>' + money(variant.compare_at_price) + '</s> <em>' + off + '% OFF</em></span>';
      }
      barPrice.innerHTML = html;
    }

    if (badgeEl) {
      if (!variant.available) { badgeEl.textContent = 'SOLD OUT'; badgeEl.hidden = false; }
      else if (variant.compare_at_price > variant.price) {
        const off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        badgeEl.textContent = off + '% OFF';
        badgeEl.hidden = false;
      } else { badgeEl.hidden = true; }
    }

    if (stockEl) {
      let line = '';
      if (!variant.available) line = 'Sold out in this colour';
      else if (variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= LOW) {
        line = 'Only ' + variant.inventory_quantity + ' left';
      }
      stockEl.textContent = line;
      stockEl.hidden = !line;
    }

    [addBtn, buyNow, barBtn].forEach(b => {
      if (!b) return;
      b.disabled = !variant.available;
      if (b.dataset.add !== undefined) b.dataset.add = variant.id;
    });
    if (addBtn) addBtn.textContent = variant.available ? 'ADD TO BAG' : 'NOTIFY ME';
    if (variantField) variantField.value = variant.id;

    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
    syncBuyBar();
  };

  /* ---------------- Size (kurtis) ---------------- */
  const sizeBox = $('#pdp-size');
  const sizeIdx = sizeBox ? +sizeBox.dataset.sizeIndex : -1;
  const colIdx = sizeBox ? +sizeBox.dataset.colourIndex : 0;
  const hasColour = !!$('#pdp-swatches');
  const currentColour = () => {
    const sel = $('#pdp-swatches .cswatch.selected');
    return sel ? sel.dataset.colour : null;
  };
  const currentSize = () => {
    const sel = sizeBox && $('.size-chip.selected', sizeBox);
    return sel ? sel.dataset.size : null;
  };
  const pickVariant = (colour, size) => VARIANTS.find(x => x.options &&
    (!hasColour || colour == null || x.options[colIdx] === colour) &&
    (size == null || x.options[sizeIdx] === size));
  const syncSizes = colour => {
    $$('.size-chip', sizeBox).forEach(chip => {
      const match = pickVariant(colour, chip.dataset.size);
      chip.classList.toggle('sold', !match || !match.available);
    });
  };
  if (sizeBox) {
    syncSizes(currentColour());
    sizeBox.addEventListener('click', e => {
      const chip = e.target.closest('.size-chip');
      if (!chip) return;
      $$('.size-chip', sizeBox).forEach(x => { x.classList.remove('selected'); x.setAttribute('aria-checked', 'false'); });
      chip.classList.add('selected');
      chip.setAttribute('aria-checked', 'true');
      const name = $('#pdp-size-name');
      if (name) name.textContent = chip.dataset.size;
      applyVariant(pickVariant(currentColour(), chip.dataset.size));
    });
  }
  const chart = $('#size-chart');
  if (chart) {
    const open = () => { chart.hidden = false; document.body.classList.add('no-scroll'); };
    const close = () => { chart.hidden = true; document.body.classList.remove('no-scroll'); };
    $$('[data-size-chart]').forEach(b => b.addEventListener('click', open));
    $$('[data-size-chart-close]', chart).forEach(b => b.addEventListener('click', close));
    chart.addEventListener('click', e => { if (e.target === chart) close(); });
  }

  const swWrap = $('#pdp-swatches');
  if (swWrap) {
    swWrap.addEventListener('click', e => {
      const sw = e.target.closest('.cswatch');
      if (!sw) return;
      e.preventDefault();
      $$('.cswatch', swWrap).forEach(x => x.classList.remove('selected'));
      sw.classList.add('selected');

      if (colourName) colourName.textContent = sw.dataset.colour;

      /* with sizes, keep the chosen size and switch only the colour */
      const variant = (sizeBox && pickVariant(sw.dataset.colour, currentSize()))
        || VARIANTS.find(x => String(x.id) === sw.dataset.variant);
      applyVariant(variant);
      if (sizeBox) syncSizes(sw.dataset.colour);

      /* the gallery becomes this colourway's own photographs */
      showColour(sw.dataset.colour);
    });
  }

  /* ---------------- Quantity ---------------- */
  const qtyWrap = $('#pdp-qty');
  const qtyVal = $('#pdp-qty-val');
  const qtyField = $('[data-quantity-field]');
  if (qtyWrap) qtyWrap.addEventListener('click', e => {
    const b = e.target.closest('[data-pqty]');
    if (!b) return;
    const variant = VARIANTS.find(x => String(x.id) === String(variantField && variantField.value));
    let cap = 99;
    if (variant && variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny') {
      cap = Math.max(variant.inventory_quantity, 1);
    }
    const next = Math.min(Math.max(+qtyVal.textContent + (+b.dataset.pqty), 1), cap);
    if (next === +qtyVal.textContent && +b.dataset.pqty > 0) { toast('That is all we have in this colour.'); return; }
    qtyVal.textContent = next;
    if (qtyField) qtyField.value = next;
  });

  /* ---------------- Buy it now ----------------
     Leaves through a real cart-form submit, not location.href = '/checkout'.

     Every other checkout entry point in this theme is a cart form with a
     <button name="checkout"> — the cart page and the drawer both are. A
     third-party checkout (Fastrr, and interception layers generally) hooks that
     submit; a raw navigation is not a submit, so it slips past the hook and lands
     on Shopify's native checkout instead. That failure is silent and partial:
     some buyers go through one checkout and some through the other, which splits
     order records, COD verification and Purchase tracking across two systems and
     makes the two sets of numbers impossible to reconcile.

     With no such app installed this ends in exactly the same place, so it is
     safe either way. */
  const goToCheckout = () => {
    const cartUrl = (window.HYRA && window.HYRA.routes && window.HYRA.routes.cart) || '/cart';
    const form = document.createElement('form');
    form.action = cartUrl;
    form.method = 'post';
    form.hidden = true;
    const submit = document.createElement('button');
    submit.type = 'submit';
    submit.name = 'checkout';
    form.appendChild(submit);
    document.body.appendChild(form);
    submit.click();
  };

  if (buyNow) buyNow.addEventListener('click', async () => {
    if (buyNow.disabled) return;
    buyNow.classList.add('is-busy');
    const id = addBtn ? addBtn.dataset.add : (variantField && variantField.value);
    const ok = await window.hyraAddToBag(id, +qtyVal.textContent || 1);
    buyNow.classList.remove('is-busy');
    if (ok) goToCheckout();
  });

  /* ---------------- Zoom lightbox ---------------- */
  const zoomEl = $('#pdp-zoombox');
  const zImg = $('#zoom-img');
  if (zoomEl && zImg) {
    const openZoom = () => {
      const slide = shown()[activeIndex()];
      const img = slide && slide.querySelector('img');
      if (!img) return;
      zImg.src = img.dataset.full || img.currentSrc || img.src;
      zImg.alt = img.alt + ', enlarged';
      zImg.classList.remove('in');
      zoomEl.hidden = false;
      document.body.classList.add('lock');
      const close = zoomEl.querySelector('.zoom__close');
      if (close) close.focus();
    };
    const closeZoom = () => { zoomEl.hidden = true; document.body.classList.remove('lock'); };
    const zoomBtn = $('#pdp-zoom');
    if (zoomBtn) zoomBtn.addEventListener('click', openZoom);
    zoomEl.querySelector('.zoom__close').addEventListener('click', closeZoom);
    zImg.addEventListener('click', () => zImg.classList.toggle('in'));
    zoomEl.addEventListener('click', e => { if (e.target === zoomEl) closeZoom(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !zoomEl.hidden) closeZoom(); });
  }

  /* ---------------- Share ---------------- */
  const shareBtn = $('#pdp-share');
  if (shareBtn) shareBtn.addEventListener('click', async () => {
    const url = location.href;
    const title = ($('#pdp-title') || {}).textContent || document.title;
    if (navigator.share) { try { await navigator.share({ title: title, url: url }); return; } catch (err) { /* dismissed */ } }
    try { await navigator.clipboard.writeText(url); toast('Link copied.'); }
    catch (err) { toast('Copy this link: ' + url); }
  });

  /* ---------------- Offer codes ---------------- */
  document.addEventListener('click', async e => {
    const c = e.target.closest('[data-copy-code]');
    if (!c) return;
    const code = c.dataset.copyCode;
    try { await navigator.clipboard.writeText(code); toast(code + ' copied'); }
    catch (err) { toast('Use code ' + code + ' at checkout'); }
  });

  /* ---------------- Tabs ---------------- */
  $$('.pdp-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      $$('.pdp-tab').forEach(t => t.classList.remove('active'));
      $$('.pdp-panel').forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      const panel = $('#panel-' + tab.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  /* ---------------- Size guide ---------------- */
  const guide = $('#size-guide');
  if (guide) {
    const openGuide = () => {
      guide.hidden = false;
      document.body.classList.add('lock');
      const c = guide.querySelector('[data-size-guide-close]');
      if (c) c.focus();
    };
    const closeGuide = () => { guide.hidden = true; document.body.classList.remove('lock'); };
    $$('[data-size-guide]').forEach(b => b.addEventListener('click', openGuide));
    $$('[data-size-guide-close]', guide).forEach(b => b.addEventListener('click', closeGuide));
    guide.addEventListener('click', e => { if (e.target === guide) closeGuide(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !guide.hidden) closeGuide(); });
  }

  /* ---------------- Pincode check ----------------
     An estimate, clearly worded as one. It does not claim serviceability the
     shop has not confirmed — it gives a date range and says where to confirm. */
  const pinBtn = $('#pin-check');
  if (pinBtn) {
    const input = $('#pin-input');
    const out = $('#pin-result');
    /* A six-digit test alone said yes to anything, so "123456" came back
       with a confident delivery date for a pincode that does not exist.
       India Post is asked whether the pincode is real before any date is
       promised. If that lookup cannot be reached the sale is never blocked
       on it — the estimate still shows, just without naming a place. */
    /* One promise for the whole country: 5–7 days. The metro/non-metro split
       this replaces quoted 3 days to some pincodes, which is faster than the
       courier actually commits to. The outer date is shown next to the range
       so the shopper has something concrete to hold on to. */
    const DAYS_MIN = 5;
    const DAYS_MAX = 7;
    const estimate = () => {
      const d = new Date(Date.now() + DAYS_MAX * 864e5);
      return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    };

    let busy = false;
    const check = async () => {
      if (busy) return;
      const pin = (input.value || '').trim();

      /* 0 and 9 are not used as the first digit of a civilian pincode. */
      if (!/^[1-8]\d{5}$/.test(pin)) {
        out.textContent = 'Enter a valid 6-digit pincode.';
        out.className = 'pin-result bad';
        return;
      }

      busy = true;
      out.textContent = 'Checking…';
      out.className = 'pin-result';

      let place = null;
      let known = null;
      try {
        const res = await fetch('https://api.postalpincode.in/pincode/' + pin, { cache: 'force-cache' });
        const data = await res.json();
        const row = Array.isArray(data) ? data[0] : null;
        if (row && row.Status === 'Success' && row.PostOffice && row.PostOffice.length) {
          known = true;
          const o = row.PostOffice[0];
          place = [o.District, o.State].filter(Boolean).join(', ');
        } else if (row && row.Status === 'Error') {
          known = false;
        }
      } catch (err) {
        known = null; /* lookup unavailable — fall through to the estimate */
      }

      busy = false;

      if (known === false) {
        out.textContent = 'We could not find that pincode. Please check and try again.';
        out.className = 'pin-result bad';
        return;
      }

      out.textContent = (place ? 'Delivering to ' + place + '. ' : '') +
        'Estimated delivery in ' + DAYS_MIN + '–' + DAYS_MAX + ' days, by ' + estimate() +
        '. Exact charges and COD eligibility are confirmed at checkout.';
      out.className = 'pin-result ok';
    };
    pinBtn.addEventListener('click', check);
    input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
  }

  /* ---------------- Recently viewed ---------------- */
  const handle = (location.pathname.split('/products/')[1] || '').split('?')[0].split('/')[0];
  const rail = $('#pdp-recent');
  const railSec = $('#pdp-recent-sec');
  if (rail && window.hyraRecent) {
    const seen = window.hyraRecent.get().filter(h => h && h !== handle).slice(0, 6);
    window.hyraRecent.push(handle);
    if (seen.length) {
      Promise.all(seen.map(h =>
        fetch('/products/' + h + '.js').then(r => (r.ok ? r.json() : null)).catch(() => null)
      )).then(list => {
        const html = list.filter(Boolean).map(p =>
          '<a class="rail-card" href="/products/' + p.handle + '">' +
            '<span class="img"><img src="' + (p.featured_image || '') + '&width=300" alt="" loading="lazy"></span>' +
            '<span class="t">' + String(p.title).split(' and ').join(' & ') + '</span>' +
            '<span class="p">' + money(p.price) + '</span>' +
          '</a>').join('');
        if (html) { rail.innerHTML = html; railSec.hidden = false; }
      });
    }
  }
})();
